import { render } from "./Refer.vue?vue&type=template&id=779e672c&scoped=true"
import script from "./Refer.vue?vue&type=script&lang=js"
export * from "./Refer.vue?vue&type=script&lang=js"

import "./Refer.vue?vue&type=style&index=0&id=779e672c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\satish\\Desktop\\WEBDEV\\assignment\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779e672c"]])

export default __exports__